export const VIEW_TYPE_OPTIONS = [
  { value: 'Discrete', label: 'Discrete' },
  { value: 'Cumulative', label: 'Cumulative' }
];
